/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var HandleMissingTags;
(function (HandleMissingTags) {
    HandleMissingTags["DISALLOW"] = "DISALLOW";
    HandleMissingTags["SKIP_ROW"] = "SKIP ROW";
    HandleMissingTags["IMPORT"] = "IMPORT";
})(HandleMissingTags || (HandleMissingTags = {}));
export function HandleMissingTagsFromJSON(json) {
    return HandleMissingTagsFromJSONTyped(json, false);
}
export function HandleMissingTagsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HandleMissingTagsToJSON(value) {
    return value;
}
